"use client";
import "../../chunk-MMUBH76A.js";
import { useMemo } from "react";
import { useWalletState } from "../../provider/index.js";
import { useInternalClient } from "../../provider/hooks/utils/useInternalClient.js";
function useActiveWallet() {
  const client = useInternalClient();
  const { selectedWallet } = useWalletState();
  return useMemo(() => {
    return client.findWallet(selectedWallet.id, selectedWallet.type, { forbidPregen: true });
  }, [client, selectedWallet]);
}
export {
  useActiveWallet
};
